import {
  BADGE_ACTION_START,
  BADGE_ACTION_ERROR,
  GET_ALL_BADGES,
  GET_BADGE,
  CREATE_BADGE,
  UPDATE_BADGE,
  DELETE_BADGE,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  badges: [],
  badge: null,
};

const badgeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case BADGE_ACTION_START:
      return { ...state, loading: true, error: null };
    case BADGE_ACTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_ALL_BADGES:
      return { ...state, loading: false, badges: action.payload };
    case GET_BADGE:
      return { ...state, loading: false, badge: action.payload };
    case CREATE_BADGE:
      return { ...state, loading: false, badges: [...state.badges, action.payload] };
    case UPDATE_BADGE:
      return {
        ...state,
        loading: false,
        badges: state.badges.map((b: any) => (b.id === action.payload.id ? action.payload : b)),
      };
    case DELETE_BADGE:
      return {
        ...state,
        loading: false,
        badges: state.badges.filter((b: any) => b.id !== action.payload),
      };
    default:
      return state;
  }
};

export default badgeReducer; 